export default "__VITE_ASSET__Bb7Bc4WM__"